import { render, staticRenderFns } from "./MyAccountLayout.vue?vue&type=template&id=797fbace&scoped=true&"
import script from "./MyAccountLayout.vue?vue&type=script&lang=js&"
export * from "./MyAccountLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797fbace",
  null
  
)

export default component.exports